import React, { FC } from 'react'

import Title from '../../common/Title/Title'

import css from './LookBookTitle.module.scss'

const LookBookTitle: FC = () => {
  return (
    <div className={css.wrapper}>
      <Title big>LookBook</Title>
    </div>
  )
}

export default LookBookTitle
